import React, { useState, useEffect, useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import {
  createTheme,
  IconButton,
  ThemeProvider,
  useTheme,
} from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import { DataGridCustomPaginationForPractise } from "components/helpers";
import { getPracticeList } from "apiHandler/actions/practice";
import { useUserData } from "components/customHooks/userDataContext";
import AddPracticeBaseModal from "components/modals/practice/AddPracticeBaseModal";
import useSnackbar from "components/customHooks/useSnackbar";

const PracticeTable = ({ showAddModal, setShowAddModal }) => {
  const [practices, setPractices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const userData = useUserData();
  const { CustomSnackbar, setSnackbarMessage } = useSnackbar();
  const theme = useTheme(); // Get the current theme

  // Extend the existing theme
  const customTheme = createTheme({
    ...theme,
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            backgroundColor: "#ffffff", // Set background for the entire grid
          },
          columnHeaders: {
            backgroundColor: "#ffffff", // Set background for column headers
          },
          virtualScroller: {
            backgroundColor: "#ffffff", // Set background for rows
          },
          footerContainer: {
            backgroundColor: "#ffffff", // Set background for footer
          },
          toolbarContainer: {
            backgroundColor: "#ffffff", // Set background for toolbar
          },
          topContainer: {
            backgroundColor: "#ffffff", // Set background for top container
          },
        },
      },
    },
  });

  const fetchPracticeList = useCallback(async () => {
    setLoading(true);
    const requestPayload = {
      email: userData?.email || "",
    };
    const response = await getPracticeList(
      requestPayload,
      userData?.access_token
    );
    setLoading(false);
    if (response)
      setPractices(response.map((r) => ({ ...r, id: r.practice_id })));
  }, [userData]);

  useEffect(() => {
    fetchPracticeList();
  }, [fetchPracticeList]);

  const columns = [
    {
      field: "",
      headerName: " ",
      width: 50,
      align: "center",
      renderCell: (e) => (
        <IconButton onClick={() => setSelectedPractice(e.row)}>
          <Edit color="secondary" />
        </IconButton>
      ),
    },
    {
      field: "practice_id",
      headerName: "Practice ID",
      width: 100,
      align: "center",
    },
    {
      field: "status_cd",
      headerName: "Status",
      width: 100,
      align: "center",
    },
    {
      field: "npi_primary",
      headerName: "NPI",
      width: 150,
      align: "center",
    },
    {
      field: "practice_name",
      headerName: "Practice Name",
      flex: 1,
      minwidth: 175,
      renderCell: (e) => (
        <button
          className="button"
          onClick={() => {
            // history.push({
            //   pathname: "/admin/practice-details",
            //   state: e.row,
            // })
          }}
        >
          {e.value}
        </button>
      ),
    },
  ];
  return (
    <ThemeProvider theme={customTheme}>
      <CustomSnackbar />
      {loading ? (
        <>loading</>
      ) : (
        <>
          <DataGrid
            pageSize={25}
            density="compact"
            rows={practices}
            columns={columns}
            loading={loading}
            autoHeight
            disableRowSelectionOnClick
            pagination
            slots={{
              pagination: DataGridCustomPaginationForPractise,
              toolbar: GridToolbar,
            }}
          />

          {showAddModal && (
            <AddPracticeBaseModal
              onClose={() => setShowAddModal(false)}
              practice={selectedPractice}
              setSnackbarMessage={setSnackbarMessage}
            />
          )}
        </>
      )}
    </ThemeProvider>
  );
};

export default PracticeTable;
